import { Navigate, NavigateProps, useParams } from 'react-router-dom';

type Props = Omit<NavigateProps, 'to'> & { to?: string };

const getHintPublisherId = (): string | undefined => {
  try {
    return (
      localStorage.getItem('gl:publisher_id') ??
      (JSON.parse(localStorage.getItem('RaStore.publisher_id') ?? 'null') as
        | string
        | null) ??
      undefined
    );
  } catch {
    return undefined;
  }
};

const NavigatePublisherIdPrefix = ({
  to = '/offers/active',
  ...props
}: Props) => {
  const { publisherId: publisherIdFromParams } = useParams<{
    publisherId: string;
  }>();

  // Prefer the URL param (inside publisher subtree); fall back to the
  // localStorage hint (e.g. when navigating to /offers/* from outside).
  const id = publisherIdFromParams ?? getHintPublisherId();

  return <Navigate {...props} to={`/publisher/${id}${to}`} />;
};

export default NavigatePublisherIdPrefix;
